import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: require('@/components/pages/login'),
            meta: {
                guest: true
            }
        },
        {
            path: '/published/:token',
            name: 'published',
            component: require('@/components/pages/published'),
            meta: {
                guest: true
            }
        },
        {
            path: '/register',
            name: 'register',
            component: require('@/components/pages/register'),
            meta: {
                guest: false,
                roles: ['admin']
            }
        },
        {
            path: '/',
            name: 'home',
            component: require('@/components/pages/home'),
            meta: {
                guest: false,
                roles: ['admin']
            }
        },
        {
            path: '/help',
            name: 'help',
            component: require('@/components/pages/help'),
            meta: {
                guest: false,
                roles: ['admin', 'inspector']
            }
        },
        {
            path: '/foresters',
            name: 'foresters',
            component: require('@/components/pages/foresters'),
            meta: {
                guest: false,
                roles: ['admin']
            }
        },
        {
            path: '/foresters/:id',
            name: 'foresters-single',
            component: require('@/components/pages/foresters-single'),
            meta: {
                guest: false,
                roles: ['admin']
            }
        },
        {
            path: '/inspections',
            name: 'inspections',
            component: require('@/components/pages/inspections'),
            meta: {
                guest: false,
                roles: ['admin', 'inspector']
            }
        },
        {
            path: '/inspections',
            name: 'inspections-filtered',
            component: require('@/components/pages/inspections'),
            meta: {
                guest: false,
                roles: ['admin', 'inspector']
            }
        },
        {
            path: '/inspections/:id',
            name: 'inspections-editor',
            component: require('@/components/pages/inspections-editor'),
            meta: {
                guest: false,
                roles: ['admin', 'inspector']
            }
        },
        {
            path: '/profile',
            name: 'profile',
            component: require('@/components/pages/profile'),
            meta: {
                guest: false,
                roles: ['admin', 'inspector']
            }
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js